import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'ccoe-cloud-onboarding',
});
export const onboardedAppsSubRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/OnboardedApplicationsView',
  id: 'onboarded-applications-view',
});

export const comingSoonSubRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/ComingSoon',
  id: 'coming-soon',
});

export const onboardingSubRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/OnboardingForm',
  id: 'onboarding-form',
});

export const onboardingOptionsSubRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/OnboardingOptions',
  id: 'onboarding-options',
});

export const statusManagementSubRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/StatusManagement',
  id: 'status-management',
});
